import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Component} from "@angular/core";
import {IAuditWebServiceClient, INotificationsCommonWebServiceClient} from "@common/resources/resources";
import {CerbaCookieService, CookieConstantes, CorrespondantStore, UserStore, PopinCompteComponent, ProfilValideDto} from "@digicerba/common";
import {TranslateService} from "@ngx-translate/core";
import * as lodash from "lodash";
import { AsiDialogService } from "@asi-ngtools/lib";

@Component({
  selector: 'cerba',
  templateUrl: './cerba.component.html',
  host: {'class': 'flex'}
})
export class CerbaPageComponent {

  context: any;

  constructor(private router: Router, private auditWebServiceClient: IAuditWebServiceClient,
              private activatedRoute: ActivatedRoute,
              private cookieService: CerbaCookieService,
              private userStore: UserStore,
              private correspondantStore: CorrespondantStore,
              private notificationService: INotificationsCommonWebServiceClient,
              private translate: TranslateService,
              public asiDialogService: AsiDialogService) {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.auditWebServiceClient.info({url: event.url}).subscribe(() => {
        });
      }
    });
  }

  ngOnInit() {
    let correspondants = this.correspondantStore.getCorrespondants();
    var cookieValue = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_CORRESPONDANT);
    if (cookieValue) {
      var selectedCorrespndant = correspondants.find(c => c.code === cookieValue);
      this.correspondantStore.setCorrespondant(selectedCorrespndant);
    } else {
      this.correspondantStore.setCorrespondant(correspondants[0]);
    }


    let tags: string[] = [];
    this.correspondantStore.getCorrespondants().forEach(c => {
      tags = tags.concat(c.tags)
    })
    tags = lodash.uniq(tags);

    if (tags.indexOf("en") != -1 && tags.indexOf("fr") == -1) {
      this.translate.use('en');
    }
    else {
      this.translate.use('fr');
    }

    let currentTags: string[] = [];
    if (this.correspondantStore.getCorrespondant()) {
      currentTags = this.correspondantStore.getCorrespondant().tags;
    }

    let profilValideDto: ProfilValideDto = this.activatedRoute.snapshot.data['profilValide'];

    this.context = {
      user: this.userStore.getUser(),
      domain: this.cookieService.getDomain(window.location.hostname),
      supportBaseUrl: this.cookieService.getSupportBaseUrl(window.location.hostname),
      nbAlerts: this.activatedRoute.snapshot.data['nbAlerts'],
      // Ajout des tags pour la gestion dynamique des outils du header et footer
      tags: tags,
      // Ajout de la gestion de la validité des informations utilisateurs
      profilValide: profilValideDto,
      openPopin: this.openPopinCompte,
      component: this,
    };

    if(profilValideDto.autoDisplayPopin){
      this.openPopinCompte(this);
    }
  }

  openPopinCompte(component: CerbaPageComponent): void{
    let asiDialog = component.asiDialogService.fromComponent(PopinCompteComponent, null);
    let profilValideDto: ProfilValideDto = component.activatedRoute.snapshot.data['profilValide'];
    asiDialog.getComponent().formattedDate = profilValideDto.dateLimite;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/cerba.component.ts